﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿<template>
  <div id="app">
    <el-container class="layout-container">
      <!-- 侧边栏 -->
      <el-aside class="sidebar" width="220px">
        <div class="sidebar-logo">
          <div class="logo-icon">📦</div>
          <div class="logo-text">库存管家</div>
        </div>

        <el-menu
          :default-active="activeMenu"
          class="sidebar-menu"
          mode="vertical"
          background-color="transparent"
          text-color="#303133"
          active-text-color="#5b8def"
          router
          unique-opened
        >
          <el-menu-item index="/">
            <el-icon><DataLine /></el-icon>
            <span>营业仪表盘</span>
          </el-menu-item>
          <el-menu-item index="/product-input">
            <el-icon><Edit /></el-icon>
            <span>商品录入</span>
          </el-menu-item>
          <el-menu-item index="/Cashier-Desk">
            <el-icon><Sell /></el-icon>
            <span>批量出货</span>
          </el-menu-item>
          <el-menu-item index="/BatchProduct-Entry">
            <el-icon><ShoppingCartFull /></el-icon>
            <span>批量入货</span>
          </el-menu-item>
          <el-menu-item index="/product-list">
            <el-icon><Goods /></el-icon>
            <span>商品列表</span>
          </el-menu-item>
          <el-menu-item index="/purchase-record">
            <el-icon><Document /></el-icon>
            <span>进货记录</span>
          </el-menu-item>
          <el-menu-item index="/sales-record">
            <el-icon><DocumentCopy /></el-icon>
            <span>销售记录</span>
          </el-menu-item>
          <el-menu-item index="/stock-management">
            <el-icon><Box /></el-icon>
            <span>库存管理</span>
          </el-menu-item>
          <el-menu-item index="/profit-calculation">
            <el-icon><BankCard /></el-icon>
            <span>盈利计算</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <el-container>
        <!-- 顶部 Header -->
        <el-header class="top-header" height="60px">
          <div class="header-left">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{ currentPageTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="header-right">
            <span class="header-date">{{ today }}</span>
            <div class="header-user">
              <el-avatar :size="32" class="user-avatar">👤</el-avatar>
              <span class="user-name">管理员</span>
            </div>
          </div>
        </el-header>

        <!-- 主内容区 -->
        <el-main class="main-content">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import dayjs from 'dayjs'
import {
  DataLine, Edit, ShoppingCartFull, Goods, Document, DocumentCopy, Box, BankCard, Sell
} from '@element-plus/icons-vue'

const route = useRoute()
const today = dayjs().format('YYYY年MM月DD日')

// 当前激活菜单（根据路由）
const activeMenu = computed(() => route.path)

// 当前页面标题（用于面包屑）
const pageTitleMap = {
  '/': '营业仪表盘',
  '/product-input': '商品录入',
  '/Cashier-Desk': '批量出货',
  '/BatchProduct-Entry': '批量入货',
  '/product-list': '商品列表',
  '/purchase-record': '进货记录',
  '/sales-record': '销售记录',
  '/stock-management': '库存管理',
  '/profit-calculation': '盈利计算'
}
const currentPageTitle = computed(() => pageTitleMap[route.path] || '首页')
</script>

<style scoped>
.layout-container {
  height: 100vh;
  display: flex;
  min-height: 0;
}

.layout-container > .el-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

/* ===== 侧栏 ===== */
.sidebar {
  background-color: var(--bg-sidebar);
  border-right: 1px solid var(--border-lighter);
  overflow: hidden;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid var(--border-lighter);
}

.logo-icon {
  font-size: 28px;
  width: 36px;
  height: 36px;
  background: var(--kpi-blue);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(91, 141, 239, 0.3);
}

.logo-text {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  letter-spacing: 1px;
}

.sidebar-menu {
  border-right: none !important;
  padding: 12px 8px;
}

.sidebar-menu :deep(.el-menu-item) {
  height: 46px;
  line-height: 46px;
  margin: 4px 0;
  padding: 0 16px !important;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-secondary);
  transition: all 0.2s;
}

.sidebar-menu :deep(.el-menu-item .el-icon) {
  font-size: 18px;
  margin-right: 10px;
  color: var(--text-tertiary);
}

.sidebar-menu :deep(.el-menu-item:hover) {
  background-color: rgba(91, 141, 239, 0.1) !important;
  color: var(--primary) !important;
}

.sidebar-menu :deep(.el-menu-item:hover .el-icon) {
  color: var(--primary) !important;
}

.sidebar-menu :deep(.el-menu-item.is-active) {
  background-color: #fff !important;
  color: var(--primary) !important;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(91, 141, 239, 0.15);
}

.sidebar-menu :deep(.el-menu-item.is-active .el-icon) {
  color: var(--primary) !important;
}

/* ===== 顶部 Header ===== */
.top-header {
  background-color: #fff;
  border-bottom: 1px solid var(--border-lighter);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.header-left :deep(.el-breadcrumb__item:last-child .el-breadcrumb__inner) {
  color: var(--primary);
  font-weight: 600;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-date {
  color: var(--text-tertiary);
  font-size: 13px;
}

.header-user {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 4px 12px 4px 4px;
  border-radius: 20px;
  transition: background-color 0.2s;
}

.header-user:hover {
  background-color: var(--primary-lighter);
}

.user-avatar {
  background: var(--kpi-blue);
  color: #fff;
  font-size: 16px;
}

.user-name {
  font-size: 14px;
  color: var(--text-primary);
  font-weight: 500;
}

/* ===== 主区 ===== */
.main-content {
  background-color: var(--bg-page);
  padding: 20px 24px;
  overflow-y: auto;
}
</style>
